<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import AppHeader from '@app/components/AppHeader.vue';
import ContentShell from '@app/components/ContentShell.vue';
import AppLayout from '@app/layouts/AppLayout.vue';
import type { ThemeContext } from '@shared/composables/useTheme';
import { useAuthStore } from '@app/stores/auth';
import { useNavigation } from '@app/composables/useNavigation';

const props = defineProps<{
  theme: ThemeContext;
}>();

const auth = useAuthStore();
const route = useRoute();
const router = useRouter();
const version = __APP_VERSION__ ?? '0.1.0';

// Even in public layout, we use navigation composable to get consistent layout classes
const { layoutClasses } = useNavigation(auth, props.theme, route);

const openHelp = () => {
  router.push({ name: 'help-center' });
};
</script>

<template>
  <AppLayout :theme-classes="theme.themeClasses.value">
    <template #header>
      <AppHeader
        :version="version"
        :is-light="theme.isLight.value"
        :theme-label="theme.themeLabel.value"
        :theme-classes="{ header: theme.themeClasses.value.header }"
        :show-scanner-shortcut="false"
        :is-mobile-menu-open="false"
        :toggle-theme="theme.toggleTheme"
        :toggle-mobile-menu="() => {}"
        @open-help="openHelp"
      />
    </template>

    <template #content>
      <ContentShell
        :layout-classes="layoutClasses"
        layout-variant="standard"
        :theme-classes="{ main: theme.themeClasses.value.main, surface: theme.themeClasses.value.surface }"
        :show-navigation="false"
        :show-mobile-navigation="false"
        :is-public-route="true"
        class="flex-1"
      >
        <slot />
      </ContentShell>
    </template>
  </AppLayout>
</template>
